// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5.5 5.5L1.5 5.5L1.5 1.5M2 5.5C2.98 3.15 5.3 1.5 8 1.5C11.59 1.5 14.5 4.41 14.5 8C14.5 11.59 11.59 14.5 8 14.5C5.11 14.5 2.66 12.61 1.81 10',
  'M8 5V8',
  'M8 8L10.12 10.12',
];
